import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { makeSelectNumberOfTimesheets } from 'services/payrollExports/selectors';

interface OwnProps {
    id: number;
}

interface ConnectedProps {
    numberOfTimesheets: number;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetSubmissionsRevertMessageComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { numberOfTimesheets } = this.props;

        const isSingle = numberOfTimesheets === 1;

        return (
            <p>
                Reverting this submission will affect {numberOfTimesheets}&nbsp;
                {isSingle ? 'timesheet' : 'timesheets'}.&nbsp;
                {isSingle ? 'This timesheet' : 'These timesheets'}&nbsp; can be
                resubmitted later.
            </p>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    numberOfTimesheets: makeSelectNumberOfTimesheets()
});

export default connect(mapStateToProps)(
    TimesheetSubmissionsRevertMessageComponent
);
